module.exports = __webpack_public_path__ + "fonts/Boing-RegularWEB.woff2";